import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const PrognosApi = lazy(() => import("@/pages/PrognosApi"));

export const Route = createFileRoute("/prognos-api")({
  head: () => seoHead("/prognos-api", { description: "Få tillgång till Elmarknad.se:s spotprisprognos via API – byggd på AI, historik och marknadsdata. Perfekt för elhandlare, industri, fintech och tjänsteföretag som vill planera utifrån förväntade elpriser upp till 30 dagar framåt." }),
  component: () => <PrognosApi />,
});
